module.exports = __webpack_public_path__ + "media/images/procne_logo-eab72dada62b777097665b721630765a.png";